<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas37bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 70px; top: 138px">
      <p>Lee el texto y completa con la palabra adecuada:</p>
    </span>

    <p class="pageElement textBaseCourier" id="text01">CASA / RESIDENCIA</p>
    <p class="pageElement textBaseCourier" id="text02">PODEROSOS / FORZUDOS</p>

    <div class="book01">
      <img src="/pages/img/sordocas/svgCas37Book.svg" />
      <p class="textBaseCourier textSimple" id="text11">
        El castillo de Warwick es uno de los mas famosos del<br />
        mundo. Se encuentra en el Reino Unido. Durante siglos fue<br />
        LA _____________ De los mas _____________ condes de inglaterra.<br />
        Actualmente es visitado por cerca de un millón de personas<br />
        POR AÑO.
      </p>
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        id="inputField01"
        class="pageElement"
      />
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
        id="inputField02"
        class="pageElement"
      />
    </div>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 70px;
  top: 50px;
}

#text01 {
  position: absolute;
  width: 430px;
  height: 41px;
  left: 105px;
  top: 187px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text02 {
  position: absolute;
  width: 430px;
  height: 41px;
  left: 105px;
  top: 230px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text11{
  position: absolute;
  width: 840px;
  height: 200px;
  left: 90px;
  top: 310px;
  font-size: 22px;
  line-height: 160%;
  text-transform: uppercase;
}
.book01 {
  position: absolute;
  left: 35.80px;
  top: 265px;
  z-index: 1;
  opacity: 0;
  animation-name: enciclopedia-appear;
  animation-duration: 0.8s;
  animation-delay: 0.3s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
  animation-fill-mode: forwards;
}
@keyframes enciclopedia-appear {
  from {
    opacity: 0;
    top: 500px;
  }
  to {
    opacity: 1;
    top: 265px;
  }
}

#inputField01 {
  position: absolute;
  width: 160px;
  height: 25px;
  left: 125px;
  top: 371px;
  z-index: 3;
}
#inputField02 {
  position: absolute;
  width: 160px;
  height: 25px;
  left: 455px;
  top: 371px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 141.mp4",
        "cas/Video 142-143.mp4",
        "cas/Video 144.mp4",
        "cas/Video 145a.mp4",
        "cas/Video 145b.mp4",
        "cas/Video 145c.mp4",
      ],
    };
  },
};
</script>